import styled, { css } from "styled-components";

interface InputStyleProps {
  $width?: string;
  $size?: "sm" | "md" | "lg";
}

export const InputBox = styled.div<InputStyleProps>`
  display: flex;
  width: ${(props) => props.$width};
  flex-direction: column;
  gap: 4px;

  input {
    font-size: 1.6rem;
    background: ${(props) => props.theme.colors.white100};
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 6px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &[type="date"],
    [type="text"],
    [type="tel"] {
      width: 100%;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.inputPlaceholder};
      font-size: 1.4rem;
    }

    &:focus {
      outline: none;
      border: 2px solid ${(props) => props.theme.colors.primary100};
    }

    &:disabled {
      background: ${(props) => props.theme.colors.inputBg};
      -webkit-text-fill-color: ${(props) => props.theme.colors.black100};
      -webkit-opacity: 1;

      &::placeholder {
        font-size: 1.4rem;
        -webkit-text-fill-color: ${(props) =>
          props.theme.colors.inputPlaceholder};
        -webkit-opacity: 1;
      }
    }
  }

  textarea {
    width: calc(100vw - 32px);
    background: ${(props) => props.theme.colors.white100};
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 6px;
    resize: none;
    flex: 1;

    &:focus {
      outline: none;
      border: 2px solid ${(props) => props.theme.colors.primary100};
    }
  }

  &:has(textarea) {
    height: 100%;
    flex: 1;
  }

  &:has(input:focus),
  &:has(textarea:focus) {
    label {
      color: ${(props) => props.theme.colors.primary100};
    }
  }

  ${(props) =>
    props.$size === "md" &&
    css`
      input {
        padding: 0 12px;
        height: 48px;
      }
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      input {
        padding: 0 16px;
        height: 56px;
        font-size: 1.6rem;
      }
    `}
`;

export const InputLabel = styled.label<InputStyleProps>`
  display: flex;
  color: ${(props) => props.theme.colors.inputLabel};
  align-items: center;

  span {
    color: ${(props) => props.theme.colors.required100};
  }

  ${(props) =>
    props.$size === "md" &&
    css`
      font-size: 1.2rem;
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 15px;
      font-size: 1.3rem;
    `}
`;
